import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_23_9086)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.2",
    d: "M5 6.012h5m-5 2.5h2.813m-1.36 4.128L5 13.512v-1.875H3.75a1.875 1.875 0 0 1-1.875-1.875v-5A1.875 1.875 0 0 1 3.75 2.887h7.5a1.875 1.875 0 0 1 1.875 1.875v2.813m-2 5.823-1.357.711a.246.246 0 0 1-.356-.256l.26-1.507-1.098-1.067a.243.243 0 0 1 .135-.416l1.518-.22.679-1.37a.245.245 0 0 1 .438 0l.68 1.37 1.517.22a.245.245 0 0 1 .202.3.24.24 0 0 1-.067.116l-1.098 1.067.259 1.506a.244.244 0 0 1-.354.257z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }